import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AssetsService } from "../../assets.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { UtilsService } from "../../../../auth/service/utils.service";
import { FlatpickrOptions } from "ng2-flatpickr";
import Italian from "flatpickr/dist/l10n/it";
import * as moment from "moment/moment";
import { AngularFileUploaderComponent } from "angular-file-uploader";
import { environment } from "../../../../../environments/environment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IAsset, IAssetMaintenace, IAssetMaintenaceForm } from "../../models/assets";

@Component({
  selector: "app-assets-detail",
  templateUrl: "./assets-detail.component.html",
  styleUrls: ["./assets-detail.component.scss"],
})
export class AssetsDetailComponent implements OnInit {
  public idAsset: number;
  public currentAsset: IAsset;
  public contentHeader: IContentHeader;
  public employees: any = [];
  public maintenanceGroup: FormGroup;
  public editFromSelectedMaintenance: FlatpickrOptions;
  public editToSelectedMaintenance: FlatpickrOptions;
  public activeTab: string = "maintenance";
  public afuConfig: {
    multiple: boolean;
    formatsAllowed: string;
    maxSize: number;
    uploadAPI: {
      url: string;
    };
    replaceTexts: {
      afterUploadMsg_success: string;
      afterUploadMsg_error: string;
      sizeLimit: string;
    };
  };
  @ViewChild("assetUploader")
  private assetUploader: AngularFileUploaderComponent;
  public selectedMaintenance: IAssetMaintenace = null;
  public pageSize: number = 10;
  public toggleModalAssociate: boolean = false;
  public AssetIdSelectedForAssociate: number = 0;
  public showErrors: boolean = false;

  constructor(
    private _activatedRoute: ActivatedRoute,
    public _assetsService: AssetsService,
    public _modalService: NgbModal,
    public _userService: UserService,
    public _formBuilder: FormBuilder,
    public _utilService: UtilsService,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    public _authenticationService: AuthenticationService,
  ) {
    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      this.idAsset = Number(params.get("id"));
    });
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_asset")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    this.maintenanceGroup = this._formBuilder.group({
      from: new FormControl("", [Validators.required]),
      to: new FormControl(null),
      note: new FormControl("", [Validators.required, Validators.minLength(5), Validators.maxLength(255)]),
      type: new FormControl("", [Validators.required]),
    });

    await this.loadCurrentAsset().then(async () => {
      this.employees = await this._userService.getList();
      this._utilService.hideLoading();

      this.editToSelectedMaintenance = {
        altFormat: "d/m/Y",
        locale: Italian.it,
        altInput: true,
        utc: true,
        minDate: "today",
        disableMobile: true,
      };

      this.editFromSelectedMaintenance = {
        altFormat: "d/m/Y",
        locale: Italian.it,
        altInput: true,
        utc: true,
        minDate: "today",
        disableMobile: true,
      };

      this.afuConfig = {
        multiple: true,
        formatsAllowed: ".pdf",
        maxSize: 5,
        uploadAPI: {
          url: environment.API_BASEURL + "/asset-file/upload/" + this.idAsset,
        },
        replaceTexts: {
          afterUploadMsg_success: await this._utilService.translate("SUCCESS_UPLOAD_FILES"),
          afterUploadMsg_error: await this._utilService.translate("ERROR_UPLOAD_FILES"),
          sizeLimit: await this._utilService.translate("FILE_SIZE_LIMIT"),
        },
      };
    });
  }

  async loadCurrentAsset() {
    await this._assetsService
      .get(this.idAsset)
      .then((response) => {
        this.currentAsset = response;
      })
      .catch(async () => {
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      });
    if (!this.currentAsset) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    this.currentAsset.oldEmployees = (this.currentAsset.oldEmployees || []).filter((item) => {
      return item.end_date != null;
    });
    if (this.currentAsset) {
      this.contentHeader = {
        headerTitle: this.currentAsset.name,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/",
            },
            {
              name: "LIST",
              isLink: true,
              link: "/dashboard/assets/list",
            },
            {
              name: "DETAIL_SINGULAR",
              isLink: false,
            },
            {
              name: this.currentAsset.name,
              isLink: false,
            },
          ],
        },
      };
    }
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.maintenanceGroup.controls[field_name].status === "INVALID";
    } else {
      return this.maintenanceGroup.controls[field_name].status === "INVALID" && this.maintenanceGroup.controls[field_name].touched;
    }
  }

  async fileSelected() {
    if (!this._authenticationService.hasCapability("view_file_asset")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    await this.loadCurrentAsset();
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
    this._changeDetectorRef.detectChanges();
  }

  openFile(file: string) {
    return this._utilService.getFile(file);
  }

  openModal(modal, data: IAssetMaintenace = null) {
    this.editToSelectedMaintenance.defaultDate = null;
    this.editFromSelectedMaintenance.defaultDate = null;
    this._modalService.open(modal, {
      centered: true,
      size: "lg",
    });

    if (data) {
      this.selectedMaintenance = JSON.parse(JSON.stringify(data));
      this.selectedMaintenance.from = this.selectedMaintenance.from.includes("T") ? this.selectedMaintenance.from.split("T")[0] : this.selectedMaintenance.from;
      this.selectedMaintenance.to =
        this.selectedMaintenance.to && this.selectedMaintenance.to.length > 0 && this.selectedMaintenance.to.includes("T") ? this.selectedMaintenance.to.split("T")[0] : this.selectedMaintenance.to;
      this.editToSelectedMaintenance.defaultDate = this.selectedMaintenance.to;
      this.editFromSelectedMaintenance.defaultDate = this.selectedMaintenance.from;
    }
  }

  closeModal() {
    this._modalService.dismissAll();
    this.maintenanceGroup.reset();
    this.selectedMaintenance = null;
    this.editToSelectedMaintenance = {
      altFormat: "d/m/Y",
      locale: Italian.it,
      altInput: true,
      utc: true,
      minDate: "today",
      disableMobile: true,
    };

    this.editFromSelectedMaintenance = {
      altFormat: "d/m/Y",
      locale: Italian.it,
      altInput: true,
      utc: true,
      minDate: "today",
      disableMobile: true,
    };
  }

  async createMaintenance() {
    this.showErrors = true;

    if (this.maintenanceGroup?.value?.from == "") {
      await this._utilService.showSWALError({ text: "INSERT_START_DATE" });
      return false;
    }

    if (this.maintenanceGroup.invalid) {
      return false;
    }

    if (!this._authenticationService.hasCapability("manage_assign_asset")) {
      window.history.back();
      return false;
    }
    let maintenance = {
      asset: this.idAsset,
      note: this.maintenanceGroup.value.note,
      type: this.maintenanceGroup.value.type,
      from: moment(this.maintenanceGroup.value.from[0]).format("YYYY-MM-DD"),
      to: this.maintenanceGroup.value.to && this.maintenanceGroup.value.to[0] ? moment(this.maintenanceGroup.value.to[0]).format("YYYY-MM-DD") : null,
    };

    if (maintenance.from > maintenance.to) {
      this._utilService.showSWALError({ text: "ERROR_DATE_INSERT" });
      return false;
    } else {
      this._utilService.showLoading();
      await this._assetsService
        .addMaintenance(maintenance)
        .then(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_ADD_MAINTENANCE" });
          await this.closeModal();
          await this.loadCurrentAsset();
        })
        .catch(() => {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_ASSOCIATE_MAINTENANCE" });
        });
    }
  }

  async dissociateAsset() {
    if (!this._authenticationService.hasCapability("manage_assign_asset")) {
      window.history.back();
      return false;
    }
    let idAsset = this.idAsset;
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DISSOCIATE_ASSET",
        icon: "warning",
        confirmButtonText: "CONFIRM_DISSOCIATE_BTN",
        customClass: {
          confirmButton: "btn btn-warning",
        },
      })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._assetsService
            .unassignAsset(idAsset)
            .then(async () => {
              this._utilService.hideLoading();
              await this.loadCurrentAsset();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DISSOCIATE_ASSET" });
            })
            .catch(() => {
              this._utilService.hideLoading();
              this._utilService.showSWALError({ text: "ERROR_DISSOCIATE_ASSET" });
            });
        }
      });
  }

  async deleteFileAsset(id: number) {
    if (!this._authenticationService.hasCapability("view_file_asset")) {
      window.history.back();
      return false;
    }
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_FILE",
        icon: "error",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._assetsService
            .deleteFile(id)
            .then(async () => {
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_FILE" });
              await this.loadCurrentAsset();
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_FILE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
  }

  async deleteMaintenance(currentMaintenance: IAssetMaintenace) {
    if (!this._authenticationService.hasCapability("delete_maintenance_asset")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    if (currentMaintenance.id > 0) {
      await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._assetsService
            .deleteCurrentMaintenance(currentMaintenance.id)
            .then(async () => {
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this.loadCurrentAsset();
              });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_REMOVE_MAINTENANCE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    }
  }

  async editCurrentMaintenance() {
    const id: number = this.selectedMaintenance.id;
    const data: IAssetMaintenaceForm = {
      note: this.selectedMaintenance.note,
      type: this.selectedMaintenance.type,
      from: null,
      to: null,
    };

    if (Array.isArray(this.selectedMaintenance.from)) {
      data.from = moment(this.selectedMaintenance.from[0]);
      if (data.from < moment()) {
        data.from = moment();
      }
      data.from = data.from.format("YYYY-MM-DD");
    } else {
      data.from = moment(this.selectedMaintenance.from).format("YYYY-MM-DD");
    }
    if (this.selectedMaintenance.to) {
      if (Array.isArray(this.selectedMaintenance.to)) {
        data.to = moment(this.selectedMaintenance.to[0]);
        if (data.to < moment()) {
          data.to = moment();
        }
        data.to = data.to.format("YYYY-MM-DD");
      } else {
        data.to = moment(this.selectedMaintenance.to).format("YYYY-MM-DD");
      }
    } else {
      data.to = null;
    }
    if (data.from > data.to) {
      this._utilService.showSWALError({ text: "ERROR_DATE_INSERT" });
      return false;
    } else {
      this._utilService.showLoading();
      await this._assetsService
        .editMaintenance(id, data)
        .then(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_MAINTENANCE" });
          this.closeModal();
          await this.loadCurrentAsset();
        })
        .catch(() => {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_EDIT_MAINTENANCE" });
        });
    }
  }

  //Funzioni associazione modale
  showModalAdd(assetId: number) {
    this.toggleModalAssociate = true;
    this.AssetIdSelectedForAssociate = assetId;
  }

  async onAssociateModalFormEvent() {
    await this.loadCurrentAsset();
  }

  //END Funzioni associazione modale

  async uploadFiles() {
    await this.loadCurrentAsset();
  }
}
